import React from "react";
import { ReferenceField, TextField, usePermissions } from "react-admin";

import { DateTimeField } from "../../../components/fields/DateFormatField";
import { SelectEnumField } from "../../../components/fields/SelectEnumField";
import { TextPopoverField } from "../../../components/fields/TextPopoverField";
import { YesNoField } from "../../../components/fields/YesNoField";
import { MyDatagrid } from "../../../components/HistoryGrid/Grid";
import { createCellStyle } from "../../../components/HistoryGrid/utils";
import { TaskServiceNames } from "../../../entities/TaskService";

export const TaskHistoryGrid = ({ nextForRecordId, ...props }) => {
	const { permissions } = usePermissions();

	if (!permissions) return null;

	const cellStyle = createCellStyle(props.data, nextForRecordId, ["updated_at"]);

	return (
		<MyDatagrid {...props} cellStyle={cellStyle}>
			<TextField
				sortable={false}
				source="updated_by_name"
				label="resources.tasks.fields.updated_by"
			/>
			<TextField sortable={false} source="title" label="resources.tasks.fields.title" />
			<TextField sortable={false} source="rank" label="resources.tasks.fields.rank" />
			<TextField sortable={false} source="rank_auto" label="resources.tasks.fields.rank_auto" />
			<DateTimeField
				sortable={false}
				source="updated_at"
				label="resources.tasks.fields.updated_at"
			/>
			<ReferenceField
				sortable={false}
				source="terminal_id"
				label="resources.tasks.fields.terminal"
				reference="terminal"
				link={false}
			>
				<TextField source="name" />
			</ReferenceField>
			<YesNoField sortable={false} source="priority" label="resources.tasks.fields.priority" />
			<SelectEnumField
				sortable={false}
				source="service"
				enumObj={TaskServiceNames}
				translate={false}
				reverse
				label="resources.tasks.fields.service"
			/>
			<ReferenceField
				sortable={false}
				source="status"
				label="resources.tasks.fields.status"
				reference="task-statuses"
				link={false}
			>
				<TextField source="name" />
			</ReferenceField>
			<TextField sortable={false} source="eta_date" label="resources.tasks.fields.eta_date" />
			<TextField sortable={false} source="eta_time" label="resources.tasks.fields.eta_time" />
			<TextField sortable={false} source="etd_date" label="resources.tasks.fields.etd_date" />
			<TextField sortable={false} source="etd_time" label="resources.tasks.fields.etd_time" />
			<ReferenceField sortable={false} source="assignee_1" label="resources.orders.fields.assignee_1" reference="company-users" filter={{ no_range: true }} link={false}>
				<TextField source="full_name" />
			</ReferenceField>
			<ReferenceField sortable={false} source="assignee_2" label="resources.orders.fields.assignee_2" reference="company-users" filter={{ no_range: true }} link={false}>
				<TextField source="full_name" />
			</ReferenceField>
			<TextPopoverField
				sortable={false}
				source="description"
				label="resources.tasks.fields.description"
			/>
			<TextPopoverField sortable={false} source="notes" label="resources.tasks.fields.notes" />
		</MyDatagrid>
	);
};
